import { post } from './axios.config';

/**
 * Serviço de conversas para Admin
 * Endpoints exclusivos que só admin pode acessar
 */
const adminConversationsService = {
  /**
   * Reseta uma conversa (apenas admin)
   * Endpoint: POST /admin/conversations/:convId/reset
   * @param {string} conversationId - ID da conversa
   * @returns {Promise<Object>}
   */
  resetConversation: async (conversationId) => {
    try {
      console.log('🔄 Admin resetando conversa:', conversationId);
      
      const response = await post(`/admin/conversations/${conversationId}/reset`);
      
      console.log('✅ Conversa resetada com sucesso');
      
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao resetar conversa:', error);
      
      if (error.response) {
        const { status, data } = error.response;
        
        if (status === 401) {
          throw new Error('Não autorizado. Faça login novamente.');
        }
        
        if (status === 403) {
          throw new Error('Você não tem permissão para resetar conversas.');
        }
        
        if (status === 404) {
          throw new Error('Conversa não encontrada.');
        }
        
        throw new Error(data?.error || data?.message || 'Erro ao resetar conversa');
      }
      
      if (error.request) {
        throw new Error('Sem resposta do servidor. Verifique sua conexão.');
      }
      
      throw new Error(error.message || 'Erro desconhecido');
    }
  },
};

export default adminConversationsService;